import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slideshow']

  connect() {
    this.element.classList.add('transition-opacity', 'duration-100', 'opacity-0')
    this.initialUrl = window.location.href
  }

  open() {
    this.element.classList.remove('hidden')
    setTimeout(() => {
      this.element.classList.remove('opacity-0')
      document.body.classList.add('overflow-hidden')
    }, 10)
    window.history.pushState({}, '', this.slideshowTarget.dataset.url)

    if (this.pageSlideshowController?.mainSwiper) this.pageSlideshowController.mainSwiper.enabled = false
  }

  close() {
    document.body.classList.remove('overflow-hidden')
    this.element.classList.add('opacity-0')
    setTimeout(() => this.element.classList.add('hidden'), 100)
    window.history.pushState({}, '', this.initialUrl)

    if (this.pageSlideshowController?.mainSwiper) this.pageSlideshowController.mainSwiper.enabled = true
  }

  get pageSlideshowController() {
    const pageSlideshow = this.application.getControllerForElementAndIdentifier(
      document.querySelector('#pictures--slideshow'),
      'pictures--slideshow'
    )

    if (!pageSlideshow?.modal) return undefined
    else return pageSlideshow
  }
}
